import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

type UsernameGuidelinesProps = {className?: string}
export const UsernameGuidelines = ({ className }: UsernameGuidelinesProps) => {
  const { t } = useTranslation('editUsername')
  const dos = t('guidelines.do.items', { returnObjects: true }) as string[]
  const donts = t('guidelines.dont.items', { returnObjects: true }) as string[]
  const wrapperClassNames = classNames(
    'ds-u-fill--gray-lightest',
    'ds-u-padding--3',
    className
  )

  return (
    <div className={wrapperClassNames}>
      <h2 className="ds-text-heading--xl">{t('guidelines.heading')}</h2>
      <div className="ds-l-row my-u-mt--12">
        <div className="ds-l-col--12 ds-l-lg-col--6">
          <h3 className="ds-text-heading--md">{t('guidelines.do.heading')}</h3>
          <ul>
            {dos.map((item, idx) => (<li className="ds-u-leading--base" key={idx}>{item}</li>))}
          </ul>
        </div>
        <div className="ds-l-col--12 ds-l-lg-col--6">
          <h3 className="ds-text-heading--md">{t('guidelines.dont.heading')}</h3>
          <ul>
            {donts.map((item, idx) => (<li className="ds-u-leading--base" key={idx}>{item}</li>))}
          </ul>
        </div>
      </div>
    </div>
  )
}
